import React from 'react';
import Layout from './components/Layout';
import Header from './components/Header';

const PDSHome = () => {
  return (
    <Layout>
      <Header 
        title="PDS"
        description="Plab Design System"
      />
      {/* ... rest of the content ... */}
    </Layout>
  );
};

export default PDSHome;
